export const selectCrossSellsList = state => state.getIn(['crossSells', 'crossSellsList'], false);
